<div class="modal-header">
  @if (!editingReport) {
    <h4 class="modal-title pull-left">
      <app-icon icon="home" iconClass="button-icon" ></app-icon> Add Report
    </h4>
  }
  @if (editingReport) {
    <h4 class="modal-title pull-left">
      <app-icon icon="home" iconClass="button-icon"></app-icon> Edit Report
    </h4>
  }

  <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()">
  </button>
</div>

<div class="modal-body">
  <form class="form-horizontal">
    <div class="form-group">
      <label for="name" class="col-sm-3 control-label">UUID</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" id="uuid" name="uuid" placeholder="UUID" [(ngModel)]="report.uuid" maxlength="100">
      </div>
    </div>
    <div class="form-group">
      <label for="name" class="col-sm-3 control-label">Report Name</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" id="report_name" name="report_name" placeholder="Report Name" [(ngModel)]="report.report_name" maxlength="100">
      </div>
    </div>
    <div class="form-group">
      <label for="roles" class="col-sm-3 control-label">Role Access</label>
      <div class="col-sm-9">
        @if (loadingRoles) {
          <div class="text-muted">Loading roles...</div>
        }
        @if (!loadingRoles && roles.length > 0) {
          <div class="role-selection-container">
            <div class="role-selection-hint text-muted small mb-2">
              Select which roles are required to access this report. If no roles are selected, the report will be available to all users.
            </div>
            <div class="role-checkboxes" style="max-height: 200px; overflow-y: auto; border: 1px solid #ddd; border-radius: 4px; padding: 10px;">
              @for (role of roles; track role.id) {
                <div class="checkbox">
                  <label style="font-weight: normal; cursor: pointer;">
                    <input
                      type="checkbox"
                      [checked]="isRoleSelected(role.id)"
                      (change)="toggleRoleSelection(role.id)"
                      style="margin-right: 8px;"
                    />
                    {{ role.name }}
                  </label>
                </div>
              }
            </div>
            @if (selectedRoleIds.length > 0) {
              <div class="text-muted small mt-2">
                {{ selectedRoleIds.length }} role(s) selected
              </div>
            }
          </div>
        }
        @if (!loadingRoles && roles.length === 0) {
          <div class="text-muted">No roles available</div>
        }
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" style="display: flex; justify-content: space-between;">
  <div>
    <button type="button" class="btn btn-danger" (click)="deleteReport()">Delete</button>
  </div>
  <div>
    <button type="button" class="btn btn-default" (click)="modalRef.hide()">Close</button>
    <button type="button" class="btn btn-primary" (click)="addUpdateReport()">Save Changes</button>
  </div>
</div>
